export const DEVICE_GROUPS_API= '/deviceGroups';
